import { render, staticRenderFns } from "./revisikiriman.vue?vue&type=template&id=3332f1ec"
import script from "./revisikiriman.vue?vue&type=script&lang=js"
export * from "./revisikiriman.vue?vue&type=script&lang=js"
import style0 from "./revisikiriman.vue?vue&type=style&index=0&id=3332f1ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports